import type { ToolCallParsed } from "../types";

export function tryParseToolCall(content: string): ToolCallParsed | null {
  try {
    const parsed = JSON.parse(content) as { name?: string; result?: string };
    if (parsed.name) return { name: parsed.name, result: parsed.result ?? "" };
  } catch {
    // Content is not tool call JSON — expected for plain text messages and older conversation formats
  }
  return null;
}

export function formatToolName(rawName: string): string {
  const [plugin, ...rest] = rawName.split(/[-.]/).filter(Boolean);
  const fn = rest.join(" ").replace(/_/g, " ");
  if (!fn) return plugin ?? rawName;
  return `${plugin}: ${fn}`;
}
